module.exports = __webpack_public_path__ + "static/img/SFU老师_皮哥.50a9473.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding/SFU/SFU老师_皮哥.png
// module id = VNKO
// module chunks = 0